(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@codev/helix-react"), require("prop-types"), require("react"), require("react-bootstrap"));
	else if(typeof define === 'function' && define.amd)
		define(["@codev/helix-react", "prop-types", "react", "react-bootstrap"], factory);
	else if(typeof exports === 'object')
		exports["2fa-setup"] = factory(require("@codev/helix-react"), require("prop-types"), require("react"), require("react-bootstrap"));
	else
		root["2fa-setup"] = factory(root["@codev/helix-react"], root["prop-types"], root["react"], root["react-bootstrap"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__codev_helix_react__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_bootstrap__) {
return 